"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-list", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M1 2.4v23.2c0 .77.63 1.4 1.4 1.4h23.2c.77 0 1.4-.63 1.4-1.4V2.4c0-.77-.63-1.4-1.4-1.4H2.4C1.63 1 1 1.63 1 2.4zm-1 0C0 1.073 1.08 0 2.4 0h23.2C26.927 0 28 1.08 28 2.4v23.2c0 1.326-1.08 2.4-2.4 2.4H2.4C1.073 28 0 26.92 0 25.6V2.4z", fill: "#BBB", fillRule: "nonzero" }),
            _react2.default.createElement("path", { d: "M7.499 10.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM7.499 15.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM7.499 20.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM12 8h10v2H12zM12 13h10v2H12zM12 18h10v2H12z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-list.js
// module id = 1888
// module chunks = 0